import { TEAM_LOGOS } from './teams';

// PVL Season 4 (2025) league standings.
const table = [
  {
    pos: 1,
    team: 'Mumbai Meteors',
    gp: 7,
    w: 6,
    l: 1,
    sd: 12,
    pd: 54,
    pts: 17,
    sw: 19,
    sl: 7,
    sr: 2.71,
    pr: 1.17,
    winPct: '85.71%',
    form: ['L', 'W', 'W', 'W', 'L'],
  },
  {
    pos: 2,
    team: 'Bengaluru Torpedoes',
    gp: 7,
    w: 5,
    l: 2,
    sd: 5,
    pd: 8,
    pts: 14,
    sw: 18,
    sl: 13,
    sr: 1.38,
    pr: 1.02,
    winPct: '71.43%',
    form: ['W', 'W', 'L', 'L', 'W'],
  },
  {
    pos: 3,
    team: 'Ahmedabad Defenders',
    gp: 7,
    w: 4,
    l: 3,
    sd: 2,
    pd: 13,
    pts: 12,
    sw: 17,
    sl: 15,
    sr: 1.13,
    pr: 1.03,
    winPct: '57.14%',
    form: ['L', 'L', 'W', 'L', 'W'],
  },
  {
    pos: 4,
    team: 'Goa Guardians',
    gp: 7,
    w: 3,
    l: 4,
    sd: 0,
    pd: 8,
    pts: 10,
    sw: 16,
    sl: 16,
    sr: 1,
    pr: 1.02,
    winPct: '42.86%',
    form: ['L', 'W', 'L', 'W', 'L'],
  },
  {
    pos: 5,
    team: 'Delhi Toofans',
    gp: 7,
    w: 3,
    l: 4,
    sd: -1,
    pd: -14,
    pts: 10,
    sw: 13,
    sl: 14,
    sr: 0.93,
    pr: 0.96,
    winPct: '42.86%',
    form: ['W', 'L', 'L', 'W', 'W'],
  },
  {
    pos: 6,
    team: 'Kochi Blue Spikers',
    gp: 7,
    w: 3,
    l: 4,
    sd: -1,
    pd: -22,
    pts: 10,
    sw: 15,
    sl: 16,
    sr: 0.94,
    pr: 0.95,
    winPct: '42.86%',
    form: ['W', 'W', 'L', 'L', 'L'],
  },
  {
    pos: 7,
    team: 'Kolkata Thunderbolts',
    gp: 7,
    w: 3,
    l: 4,
    sd: -2,
    pd: -17,
    pts: 10,
    sw: 12,
    sl: 14,
    sr: 0.86,
    pr: 0.95,
    winPct: '42.86%',
    form: ['L', 'W', 'L', 'L', 'W'],
  },
  {
    pos: 8,
    team: 'Chennai Blitz',
    gp: 7,
    w: 4,
    l: 3,
    sd: -1,
    pd: 10,
    pts: 9,
    sw: 14,
    sl: 15,
    sr: 0.93,
    pr: 1.02,
    winPct: '57.14%',
    form: ['L', 'W', 'W', 'L', 'L'],
  },
  {
    pos: 9,
    team: 'Hyderabad Black Hawks',
    gp: 7,
    w: 3,
    l: 4,
    sd: -3,
    pd: -10,
    pts: 9,
    sw: 12,
    sl: 15,
    sr: 0.8,
    pr: 0.97,
    winPct: '42.86%',
    form: ['L', 'W', 'W', 'L', 'L'],
  },
  {
    pos: 10,
    team: 'Calicut Heroes',
    gp: 7,
    w: 1,
    l: 6,
    sd: -11,
    pd: -30,
    pts: 4,
    sw: 7,
    sl: 18,
    sr: 0.39,
    pr: 0.92,
    winPct: '14.29%',
    form: ['L', 'W', 'L', 'L', 'L'],
  },
];

export const standings = table.map((row) => ({ ...row, logo: TEAM_LOGOS[row.team] }));
